import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface SaveBeforeEvaluationProvider {
  saveBeforeEvaluation(): Observable<void>;
}

export const SAVE_BEFORE_EVALUATION_PROVIDER =
  new InjectionToken<SaveBeforeEvaluationProvider>(
    'SAVE_BEFORE_EVALUATION_PROVIDER',
  );
